<script setup lang="ts">
  import { computed } from 'vue';
  import BaseDataTable from '@/shared/ui/data-table/BaseDataTable.vue';
  import TestContentTableRow from './TestContentTableRow.vue';
  import { OrderOptions } from '@/shared/lib';
  import type { DocumentRevision, FilterOptions } from '@/entities/Document';
  import type { ProofRevision } from '../model/types';

  const props = defineProps<{
    revisions: DocumentRevision[];
    error: string | null;
    page: number;
    orderOptions?: OrderOptions[];
    filterModal: any;
  }>();

  const emit = defineEmits<{
    (e: 'update:sort', sortCamp: string, orderFlow: string): void;
    (e: 'update:filter', filters: FilterOptions): void;
  }>();

  const COLUMNS = [
    { text: 'Data da solicitação', class: 'px-6 py-4.5' },
    { text: 'Nome do documento', class: 'px-6 py-4.5' },
    { text: 'Elaboração', class: 'px-6 py-4.5' },
    { text: 'Aprovação', class: 'px-6 py-4.5' },
    { text: 'Conteúdo prova', class: 'px-6 py-4.5' },
  ];

  const proofRevisions = computed<ProofRevision[]>(() => {
    return props.revisions.map((revision) => ({
      id: revision.id,
      createdAt: revision.createdAt,
      documentName: revision.document?.name ?? '',
      elaboratedBy: revision.document?.createdBy?.name ?? '',
      approvedBy: revision.approvedBy?.name ?? '',
    }));
  });
</script>

<template>
  <BaseDataTable
    title="Conteúdos pendentes"
    :columns="COLUMNS"
    :data="proofRevisions"
    :error="error"
    :page="page"
    :order-options="orderOptions"
    :filter-modal="filterModal"
    :colspan="8"
    error-message="Erro ao carregar conteúdo de provas"
    empty-message="Nenhum conteúdo prova para mostrar"
    @update:sort="(sortCamp, orderFlow) => emit('update:sort', sortCamp, orderFlow)"
    @update:filter="(filters: FilterOptions) => emit('update:filter', filters)"
  >
    <template #row="{ items }">
      <TestContentTableRow
        v-for="revision in items"
        :key="revision.id"
        :proof-revision="revision"
      />
    </template>
  </BaseDataTable>
</template>
